export const allSelectedPlans = (state) => state.CustomizeOrder.allSelectedPlans;
export const selectedContract = (state) => state.CustomizeOrder.selectedContract;
export const servicesInCart = (state) => state.CustomizeOrder.servicesInCart;
export const internetProductsInCart = (state) => state.FloatingCart.internet;
export const tvProductsInCart = (state) => state.FloatingCart.tv;
export const bdvProductsInCart = (state) => state.FloatingCart.phone;
export const voiceProductsInCart = (state) => state.FloatingCart.voice;
export const allFlowRequestPayLoads = (state) => state.CustomizeOrder.allFlowRequestPayLoads;
export const selectedBundleInfoRequestBodyForTv = (state) => state.CustomizeOrder.selectedBundleInfoRequestBodyForTv;
export const allSelectedNonDoBundlePlans = (state) => state.CustomizeOrder.allSelectedNonDoBundlePlans;
export const selectedPremiumSupportPlans = (state) => state.CustomizeOrder.selectedPremiumSupportPlans;
export const serviceCallOpt = state => state.CustomizeOrder.serviceCallOpt;
export const selectedOpt = state => state.CustomizeOrder.selectedOpt;
export const selectedStaticIPId = (state) => state.CustomizeOrder.selectedStaticIPId;
